import React from 'react';
import { useTranslation } from 'react-i18next';

import { BlogSection } from '../BlogSection/BlogSection';
import { OffersGrid } from '../../shared/OffersGrid/OffersGrid';
import { GlacierVideoSection } from '../GlacierVideoSection/GlacierVideoSection';
import { GlacierVideoExploration } from '../MeaningfulExplorationSection/GlacierVideoExploration/GlacierVideoExploration';

import Hero from '../../Hero/Hero';
import Footer from '../../Footer/Footer';
import InstagramSection from '../InstagramSection';
import InteractiveMap from '../InteractiveMap/InteractiveMap';
import HorizontalCarousel from '../..//HorizontalCarousel/HorizontalCarousel';
import ImageTextPaginated from '../../shared/ImageTextPaginated/ImageTextPaginated';
import { IntroPanel, ImageCollagePanel, FullWidthPanel, OutroPanel } from '../../HorizontalCarousel/panels';

import './AllSectionsUnified.css';
import { images } from '../../shared/assets';


export const AllSectionsUnified: React.FC = () => {
  const instagramPosts = [
    { src: images.film13, alt: "Instagram 1" },
    { src: images.filmVideo1, alt: "Instagram 2", isVideo: true },
    { src: images.film14, alt: "Instagram 3" },
    { src: images.film15, alt: "Instagram 4" }
  ];

  const { t } = useTranslation();

  const fixedOffers = [
    {
      id: 1,
      image: '/assets/images/offers/offer-01.jpg',
      tag: t('pages/home:offers.tag'),
      title: t('pages/home:offers.items.combine.title'),
      moreLink: "/packages/combine-three",
      moreLabel: t('properties/santa-catarina:journey.cards.combine.viewMore')
    },
    {
      id: 2,
      image: 'https://images.ctfassets.net/hz1mviiqoqof/15Cp3o6XVDv7icoa9wFixB/bc2c3f2c8e8fade33be67101c8b93cd0/rainbow-falls.jpg',
      tag: t('pages/home:offers.tag'),
      title: t('pages/home:offers.items.stayLonger.title'),
      moreLink: "/packages/stay-longer",
      moreLabel: t('properties/santa-catarina:journey.cards.combine.viewMore')
    },
    // {
    //   id: 3,
    //   image: '/assets/Awasi Atacama-17.jpg',
    //   tag: t('pages/home:offers.tag'),
    //   title: t('pages/home:offers.items.wellness.title'),
    //   moreLink: "/packages/re-energize",
    //   moreLabel: t('properties/santa-catarina:journey.cards.combine.viewMore')
    // }
  ];

  const offers = fixedOffers;

  return (
    <div className="all-sections-unified">
      <Hero
        backgroundVideo="https://videos.ctfassets.net/hz1mviiqoqof/QgxifSyASmczemC0h46Pm/7a3b799704739fbaae22626ecea1b7ff/%C3%90_%C3%90_%C3%91_%C3%90_%C3%90%C2%B5%C3%90_%C3%90_%C3%90_%C3%90_%C3%91_%C3%90%C2%B5%C3%90_%C3%91_%C3%90_%C3%90_%C3%91_%C3%91_%C3%91__01.mp4"
        heading={t('pages/home:hero.title')}
      />

      {/* <script type="text/javascript" src="//contact-api.inguest.com/bundles/revinatecontactapi/js/revinate-form.js?v=1"></script> */}
      {/* <script type="text/javascript">  </script> */}
      {/* token="31a2fcc2-09b6-40d1-b8b7-163355599ab8" */}
      {/* <form id="revinate_contact_api_form" onSubmit={submitToAll}>
        <fieldset>
          <legend> Revinate Contact Sign Up Form Sample.</legend>
          <div>
            <label>Also Subscribe to:</label>
            <div className="checkbox-group">
              <label htmlFor="Awasi Santa Catarina">
                <input type="checkbox" id="Awasi Santa Catarina" name="sendTo" value="3f9546cd-789a-418a-8c49-2fbcb219409d" />
                Awasi Santa Catarina
              </label>
              <label htmlFor="Awasi Atacama">
                <input type="checkbox" id="Awasi Atacama" name="sendTo" value="d4785d77-8bb2-437a-8afa-d5f06a930e59" />
                Awasi Atacama
              </label>
              <label htmlFor="Awasi Iguazu">
                <input type="checkbox" id="Awasi Iguazu" name="sendTo" value="1f4b4ca1-a258-45fb-b577-9c25d1104a22" />
                Awasi Iguazu
              </label>
              <label htmlFor="Awasi Patagonia">
                <input type="checkbox" id="Awasi Patagonia" name="sendTo" value="ac275c08-3784-4c62-8133-2b95619c0850" />
                Awasi Patagonia
              </label>
              <input type="checkbox" id="group" name="sendTo" value="31a2fcc2-09b6-40d1-b8b7-163355599ab8" checked hidden />
            </div>
          </div>
          <div>
            <label>Email</label>
            <input className="long" type="email" name="email" required />
          </div>
          <div className="button">
            <button type="submit">Sign Me Up !</button>
          </div>
        </fieldset>
      </form> */}
      {/* <style scoped> label {display: inline-block; width: 130px; } label.required:after {content: " *"; color: red; } fieldset {width: 500px; padding: 1em; border: 3px solid #CCC; } input {margin: 1px 5px 1px 5px; width: 145px; padding: 3px; border-width: 2px; } input.long {width: 300px } div.checkbox-group {padding: 10px 0; } div.checkbox-group label {width: 100%; } input[type=checkbox] {width: 15px; height: 15px; margin-left: 0; } div.button {margin - top: 1em; text-align: center; } </style> */}

      <HorizontalCarousel >
        <IntroPanel />
        <ImageCollagePanel />
        <FullWidthPanel />
        <OutroPanel />
      </HorizontalCarousel>

      <GlacierVideoSection />
      <GlacierVideoExploration />
      <InteractiveMap />

      <ImageTextPaginated
        backgroundColor="#49413D"
        foregroundColor="#F3F3F3"
        heading={t('pages/home:carbon.headline')}
        slides={[
          {
            heading: t('pages/home:carbon.content.conservation.title'),
            description: t('pages/home:carbon.content.conservation.description'),
            imageUrl: images.destinationsCarbonNeutralBg
          },
          {
            heading: t('pages/home:carbon.content.wildlife.title'),
            description: t('pages/home:carbon.content.wildlife.description'),
            imageUrl: images.destinationsCarbonNeutralBg
          },
          {
            heading: t('pages/home:carbon.content.sustainability.title'),
            description: t('pages/home:carbon.content.sustainability.description'),
            imageUrl: images.destinationsCarbonNeutralBg
          },
          {
            heading: t('pages/home:carbon.content.unGoals.title'),
            description: t('pages/home:carbon.content.unGoals.description'),
            imageUrl: images.destinationsCarbonNeutralBg
          },
          {
            heading: t('pages/home:carbon.content.santaCatarinaPractices.title'),
            description: t('pages/home:carbon.content.santaCatarinaPractices.description'),
            imageUrl: images.destinationsCarbonNeutralBg
          },
          {
            heading: t('pages/home:carbon.content.beeRoute.title'),
            description: t('pages/home:carbon.content.beeRoute.description'),
            imageUrl: images.destinationsCarbonNeutralBg
          },
        ]}
      />

      <OffersGrid
        heading={t('pages/home:offers.section.title')}
        description={t('pages/home:offers.section.description')}
        ctaLabel={t('pages/home:offers.section.cta')}
        ctaLink="/packages"
        offers={offers}
      />

      {/* <video className="premium-video" src="/assets/videos/video-02.mp4" autoPlay loop muted /> */}

      <BlogSection />

      <InstagramSection posts={instagramPosts} />
      <Footer variant="default" />
    </div>
  );
};